<template>
  <div style="padding: 0 20px 20px 20px">
    <fieldset style="padding: 15px">
      <legend>稿件基本信息</legend>
      <h3 style="margin-bottom: 20px">{{ article.title }}</h3>
      <el-descriptions border>
        <el-descriptions-item label="作者">{{ article.authorName }}</el-descriptions-item>
        <el-descriptions-item label="投稿日期">{{ article.createTime | datefmt("YYYY-MM-DD HH:mm:ss") }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ article.contactTelephone }}</el-descriptions-item>
        <el-descriptions-item label="电子邮箱">{{ article.contactEmail }}</el-descriptions-item>
      </el-descriptions>
    </fieldset>

    <fieldset style="padding: 15px; margin-top: 20px">
      <legend>发票信息</legend>
      <el-descriptions border>
        <el-descriptions-item label="发票抬头">{{ invoice.companyName }}</el-descriptions-item>
        <el-descriptions-item label="开票税号">{{ invoice.regNumber }}</el-descriptions-item>
        <el-descriptions-item label="开票金额">{{ invoice.money }}</el-descriptions-item>
        <el-descriptions-item label="发票内容">出版费</el-descriptions-item>
        <el-descriptions-item label="备注信息">{{ invoice.remarks }}</el-descriptions-item>
      </el-descriptions>
    </fieldset>

    <fieldset style="padding: 15px; margin-top: 20px">
      <legend>电子发票传达途径信息</legend>
      <el-descriptions border>
        <el-descriptions-item label="邮箱地址">{{ invoice.email }}</el-descriptions-item>
      </el-descriptions>
    </fieldset>

    <fieldset style="padding: 15px; margin-top: 20px">
      <legend>其他信息</legend>
      <el-descriptions border>
        <el-descriptions-item label="申请时间">{{ invoice.createTime | datefmt2("YYYY-MM-DD HH:mm") }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag type="primary" v-if="invoice.isIssue == 1">已申请</el-tag>
          <el-tag type="warning" v-else-if="invoice.isIssue == 2">正在开具中</el-tag>
          <el-tag type="success" v-else-if="invoice.isIssue == 3">已开具</el-tag>
          <el-tag type="danger" v-else-if="invoice.isIssue == 4">已作废</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="开出时间">{{ invoice.issueTime | datefmt2("YYYY-MM-DD HH:mm") }}</el-descriptions-item>
      </el-descriptions>
    </fieldset>

    <div style="margin-top: 20px">
      <el-button type="primary" @click="editInfo" v-if="!onlyShow">信息有误，重新修改</el-button>
      <el-button type="default" @click="close">关闭</el-button>
    </div>
  </div>
</template>

<script>
import articleApi from "@/api/article"
import invoiceApi from "@/api/invoice"
export default {
  props: {
    invoiceId: {
      type: Number,
      require: true,
    },
    onlyShow: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data() {
    return {
      articleId: null,
      article: {},
      invoice: {},
    }
  },

  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      invoiceApi.getOne(this.invoiceId).then((res) => {
        if (res.code == 0) {
          this.invoice = res.data
          this.articleId = res.data.articleId

          articleApi.getArticleBaseInfo(this.articleId).then((res) => {
            if (res.code == 0) {
              this.article = res.data
            }
          })
        }
      })
    },

    editInfo() {
      this.$emit("intoEditing", this.invoiceId)
    },

    close() {
      this.$emit("close")
    },
  },
}
</script>
